module.exports = __webpack_public_path__ + "93f253f399c1ce7ea2abe2942599d96a.png";